import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Card } from 'ui';
import DateFormat from 'constants/date_format';
import JoinVideoMeetingButton from 'components/InPersonTraining/shared/JoinVideoMeetingButton';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

import { localTime } from 'components/InPersonTraining/shared/LocalTimeAndTimeZone';
import AttendanceStatus from '../../shared/AttendanceStatus';
import SessionDetails from '../../shared/SessionDetails';

const hasRSVP = attendance => {
  if (!attendance) return false;
  if (attendance.status === 'awaiting_reply') return false;
  return true;
};

const EventsDashboardEvent = ({
  event,
  session,
  attendance,
  urls,
  showNoStatus,
  canRegister,
  showLimitMet,
  showDidNotAttend,
  showRsvpStatus,
  showLimitMetOverrideStatus,
}) => (
  <Card
    url={canRegister && urls.register}
    className="EventsDashboardEvent EventsCardShadow MyTrainingEventsCard ff-ss mb-24 d-b"
  >
    <div className="MyTrainingEventsCard-calendarGraphic d-f ai-c">
      <div className="MyTrainingEventsCard-calendarGraphic--month">
        {moment(
          localTime(session.startTime),
          DateFormat.fixed.ISO8601_LOCAL,
        ).format(DateFormat.fixed.LONG_MONTH)}
      </div>
      <div className="MyTrainingEventsCard-calendarGraphic--day">
        {moment(
          localTime(session.startTime),
          DateFormat.fixed.ISO8601_LOCAL,
        ).format(DateFormat.fixed.NUMBER_DAY)}
      </div>
    </div>
    <Card.Content padding="medium">
      <div className="mb-8">
        <Text className="text-wrap" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
          {event.name}
        </Text>
      </div>
      <SessionDetails className="mt-8" eventId={event.id} session={session} />
      {showRsvpStatus && !showLimitMetOverrideStatus && (
        <div className="mt-8">
          <AttendanceStatus status={attendance.status} />
        </div>
      )}
      {showLimitMetOverrideStatus && (
        <div className="mt-8">
          <AttendanceStatus status="limit_met" />
        </div>
      )}
      {showNoStatus && (
        <Text className="d-ib mt-8 h-td-u" variant={TEXT_VARIANTS.BODY_LINK}>
          {t('in_person_training.attendance.phrase.no_status')}
        </Text>
      )}
      {session.upcoming && showLimitMet && (
        <div className="mt-8">
          <AttendanceStatus status="limit_met" />
        </div>
      )}
      {showDidNotAttend && (
        <div className="mt-8">
          <AttendanceStatus status="did_not_attend" />
        </div>
      )}
      {!session.upcoming && showLimitMet && (
        <div className="mt-8">
          <AttendanceStatus status="did_not_attend" />
        </div>
      )}
      <JoinVideoMeetingButton
        rsvpStatus={attendance?.status}
        className="mt-8"
        session={session}
        event={event}
      />
    </Card.Content>
  </Card>
);

const mapStateToProps = (
  {
    meta: {
      policies: { canChangeAttendance },
      features,
    },
  },
  { session, attendance },
) => {
  const capacityMet =
    session.maxAttendees && session.totalRegistered >= session.maxAttendees;

  const hasNoRSVP = !hasRSVP(attendance);
  const limitMet = capacityMet;
  const canRSVP = session.upcoming || canChangeAttendance;
  const positiveStatus =
    !hasNoRSVP && ['did_attend', 'will_attend'].includes(attendance.status);

  const willNotAttend = !hasNoRSVP && attendance.status === 'will_not_attend';

  return {
    showNoStatus: hasNoRSVP && canRSVP && !limitMet,
    showLimitMet: hasNoRSVP && canRSVP && limitMet,
    showDidNotAttend: hasNoRSVP && !canRSVP,
    canRegister:
      (canRSVP && !limitMet) ||
      (!session.upcoming && canChangeAttendance && !limitMet) ||
      (canRSVP && limitMet && positiveStatus),

    // Limit met info takes precedence over attendance status when cap is met
    showLimitMetOverrideStatus: !hasNoRSVP && willNotAttend && limitMet,
    showRsvpStatus: !hasNoRSVP,
  };
};

export default connect(mapStateToProps)(EventsDashboardEvent);
